<template>
  <div id="app" class="pusher">
    <router-view />
  </div>
</template>

<script>

  import firebaseApp from "firebase/app"
  import firebaseConfig from "@/config/firebase.config"

  export default {
    created() {
      firebaseApp.initializeApp(firebaseConfig)
    }
  }
  
</script>


